import LayoutWithoutNavFooter from '@/components/layouts/LayoutWithoutNavFooter';

export default [{
    path: '/history-tracking',
    navbar: false,
    title: 'history_tracking',
    icon: 'ion ion-md-maps',
    component: LayoutWithoutNavFooter,
    meta: { perm: 'Navbar.HistoryTracking' },
    children: [{
        path: '',
        title: 'history_tracking',
        icon: 'ion ion-md-settings',
        name: 'history_tracking',
        component: () =>
            import ('@/pages/HistoryTracking/HistoryTracking'),
    }, ],
}, ];